import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import { Button } from '@arnsbogroup/react-voicearchive'

const Help = () => {
  const { formatMessage } = useIntl()

  return (
    <div>
      <div className="font-medium text-4xl">
        <FormattedMessage {...messages.title } />
      </div>

      <div className="text-gray-700 mt-6 whitespace-pre-line">
        <FormattedMessage {...messages.subtitle } />
      </div>

      <div className="space-y-4 mt-10">
        <a href={`mailto:${formatMessage(messages.helpEmail)}`}>
          <Button>
            <FormattedMessage {...messages.sendEmail } />
          </Button>
        </a>
      </div>
    </div>
  )
}

export default Help
